import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  mergeWebsocketDocuments,
  removeDocumentById,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformUserTaxOptOutReason } from './user-tax-opt-out-reasons.transformers';
import type { UserTaxOptOutReasonsCollection } from './user-tax-opt-out-reasons.types';

const USER_TAX_OPT_OUT_REASONS = 'userTaxOptOutReasons';

export function userTaxOptOutReasonsReducer(
  state: CollectionStateSlice<UserTaxOptOutReasonsCollection> = {},
  action: CollectionActions<UserTaxOptOutReasonsCollection>,
): CollectionStateSlice<UserTaxOptOutReasonsCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (action.payload.type === USER_TAX_OPT_OUT_REASONS) {
        const { result, ref, order } = action.payload;
        return mergeDocuments<UserTaxOptOutReasonsCollection>(
          state,
          transformIntoDocuments(result.reasons, transformUserTaxOptOutReason),
          order,
          ref,
        );
      }

      return state;

    case 'API_PUSH_SUCCESS':
      if (action.payload.type === USER_TAX_OPT_OUT_REASONS) {
        const { ref, result } = action.payload;
        return mergeWebsocketDocuments<UserTaxOptOutReasonsCollection>(
          state,
          transformIntoDocuments([result], transformUserTaxOptOutReason),
          ref,
        );
      }

      return state;

    case 'API_SET_SUCCESS':
      if (action.payload.type === USER_TAX_OPT_OUT_REASONS) {
        const { ref, result, originalDocument } = action.payload;

        const newState = removeDocumentById<UserTaxOptOutReasonsCollection>(
          ref,
          state,
          originalDocument.id,
        );

        return mergeWebsocketDocuments<UserTaxOptOutReasonsCollection>(
          newState,
          transformIntoDocuments([result], transformUserTaxOptOutReason),
          ref,
        );
      }

      return state;

    case 'API_DELETE_SUCCESS':
      if (action.payload.type === USER_TAX_OPT_OUT_REASONS) {
        const { originalDocument, ref } = action.payload;
        return removeDocumentById(ref, state, originalDocument.id);
      }

      return state;

    default:
      return state;
  }
}
